// src/config.ts
// ═══════════════════════════════════════════════════════════════════════
//  ЦЕНТРАЛЬНЫЙ КОНФИГ — все изменяемые значения в одном месте
// ═══════════════════════════════════════════════════════════════════════

// ─── Backend URLs ─────────────────────────────────────────────────────
// Задаются через .env файл в корне проекта:
//   REACT_APP_USE_LOCAL_API=true   → запросы идут на /api/{route} (same-origin)
//   REACT_APP_USE_LOCAL_API=false  → запросы идут на REACT_APP_BACKEND_HOST/{route}
//   REACT_APP_BACKEND_HOST=https://your-api.example.com
//   REACT_APP_WS_HOST=your-api.example.com
//   REACT_APP_WS_PATH=   (оставить пустым если нет суб-пути)
export const USE_LOCAL_API: boolean = process.env.REACT_APP_USE_LOCAL_API === 'true';

export const BACKEND_HOST: string = USE_LOCAL_API
  ? '/api'
  : (process.env.REACT_APP_BACKEND_HOST ?? '');

// При USE_LOCAL_API сокеты идут на тот же домен, что и фронт, с суб-путём /api:
//   wss://<домен-фронта>/api/app/{key}
export const WS_HOST: string = USE_LOCAL_API
  ? window.location.hostname
  : (process.env.REACT_APP_WS_HOST ?? '');

export const WS_PATH: string | undefined = USE_LOCAL_API
  ? '/api'
  : process.env.REACT_APP_WS_PATH || undefined;

// ─── Pusher WebSocket key ──────────────────────────────────────────────
// Задаётся через .env файл: REACT_APP_PUSHER_APP_KEY=...
export const PUSHER_APP_KEY: string =
  process.env.REACT_APP_PUSHER_APP_KEY ?? 'b073b18079e185c24d42';
